<section style="background-color: white;" class="section-container">
  <div class="container-fluid">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-md-9 col-lg-6 col-xl-5 text-center">
        <img [src]="logo()" class="img-fluid mx-auto mt-5 mt-xl-0" alt="Logo">
        <p class="display-6 mt-3 text-center">{{title()}}</p>
      </div>
      <div class="col-10 col-xs-6 col-md-8 col-lg-6 col-xl-4 offset-xl-1">
        <h2 class="h4 mb-3">{{'FORGOT_PASSWORD' | translation}}</h2>

        @if (sent()) {
          <div class="alert alert-success" role="status">{{'FORGOT_PASSWORD_SENT' | translation}}</div>
        } @else {
          <p>{{'FORGOT_PASSWORD_LEAD' | translation}}</p>

          <form (ngSubmit)="submit()">
            <div class="form-outline mb-2">
              <label class="form-label" for="forgot-username">{{'USERNAME' | translation}}</label>
              <input [(ngModel)]="userName" name="userName" type="text" id="forgot-username"
                autocomplete="username" class="form-control form-control-lg"
                placeholder="{{'USERNAME' | translation}}" />
            </div>

            <div class="d-grid my-3">
              <button type="submit" class="btn btn-primary" [disabled]="!canSubmit()">
                {{'FORGOT_PASSWORD_SEND' | translation}}
              </button>
            </div>
          </form>
        }

        <p class="small fw-bold mt-2 pt-1">
          <a [routerLink]="loginLink()">{{'RETURN_TO_LOGIN' | translation}}</a>
        </p>

        <div class="col-6">
          <app-language-selector></app-language-selector>
        </div>
      </div>
    </div>
  </div>
</section>
